import { render, staticRenderFns } from "./GraficoResultadoPorCanal.vue?vue&type=template&id=71c2f2e8&scoped=true"
import script from "./GraficoResultadoPorCanal.vue?vue&type=script&lang=ts"
export * from "./GraficoResultadoPorCanal.vue?vue&type=script&lang=ts"
import style0 from "./GraficoResultadoPorCanal.vue?vue&type=style&index=0&id=71c2f2e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c2f2e8",
  null
  
)

export default component.exports